import PropTypes from 'prop-types';
import r from 'render-dom';
import styled from 'styled-components';

const Container = styled.div`
    align-items: center;
    display: flex;
    flex: 1;
    justify-content: center;
`;

const Content = styled.div`
    align-items: center;
    display: flex;
`;

const Point = styled.div`
    border-radius: 10px;
    background: ${({ isPrev, isSelected }) => {
        if (isSelected) {
            return '#03DE74';
        }
        if (isPrev) {
            return 'black';
        }
        return '#a0a0a0';
    }};
    height: 7px;
    margin-left: 15px;
    margin-right: 15px;
    width: 7px;
`;

const propTypes = {
    currentStep: PropTypes.number.isRequired,
    steps: PropTypes.array.isRequired,
};

export default function Indicator({ currentStep, steps }) {
    return (
        r(Container, [
            r(Content, [
                steps.map((step, index) => {
                    return r(Point, {
                        isPrev: currentStep > index,
                        isSelected: currentStep === index,
                        key: index,
                    });
                })
            ])
        ])
    );
}

Indicator.propTypes = propTypes;
